
import getRootPage from './pages';
//import * as Sentry from "@sentry/browser";
//import { Integrations } from "@sentry/tracing";

//Sentry.init({
//    dsn: "https://c58f3cb868cf46e8a496e0b6a199180b@o366335.ingest.sentry.io/5167617",
//    integrations: [new Integrations.BrowserTracing()],

//    // Set tracesSampleRate to 1.0 to capture 100%
//    // of transactions for performance monitoring.
//    // We recommend adjusting this value in production
//    tracesSampleRate: 1,
//});

function importAll(r) {
    return r.keys().map(r);
}

const bindings = importAll(require.context('./bindings', false, /\.(js)$/));
const extenders = importAll(require.context('./bindings/extenders', false, /\.(js)$/));
const preprocessors = importAll(require.context('./bindings/preprocessors', false, /\.(js)$/));
const spec = importAll(require.context('./bindings/special-import', false, /\.(js)$/));
const libs = importAll(require.context('./libs', false, /\.(js)$/));
const $api = importAll(require.context('./api', false, /\.(js)$/));

$(function () {
    var appRoot = $('body').attr('data-jsapproot');

    if (appRoot) {
        var page = getRootPage(appRoot);

        page = new page();

        window.currentPage = page;

        page.onInit();

        ko.options.deferUpdates = !!page.deferUpdates;
        ko.options._autosaveConfig = page.autosaveConfig;

        ko.applyBindings(page, window.document.body);

        page.onRender();
    }

    document.arrive('*', function (el) {
        // $(el).bootstrapMaterialDesign();
    });
});

window.isMobileBrowser = function () {
    return window.matchMedia('(max-width: 768px)').matches;
}